const texts = {
	main: `
        <p>Ставки - выше. Охват - шире. Выплаты - быстрее. Доброе человеческое отношение!</p>
        <p>Заполни заявку сейчас и начни зарабатывать больше вместе с лидером рынка.</p>
    `,
};

export default texts;
